import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { of, from } from 'rxjs';
import { debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ReservaDoctorService } from 'src/app/services/reserva-doctor.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { GeneralService } from 'src/app/services/general.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { URL_DOCS } from 'src/app/config/config';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-orden-form',
  templateUrl: './orden-form.component.html',
  styleUrls: ['./orden-form.component.css'],
  providers: [DatePipe]
})
export class OrdenFormComponent implements OnInit {

  _title = 'Documentos > Talonario digital';
  _subtitle = 'Orden de examen';

  usuario: any = {};
  pageInfo: any = {};
  currentStep = 0;
  URL_DOCS = URL_DOCS;

  steps = {
    searchPatient: true,
    examOrderData: false,
    examOrderSignature: false,
    examOrderSummary: false
  };

  uiSteps = [
    { title: 'Selecciona el paciente', icon: 'fi fi-rr-user' },
    { title: 'Escribe la orden', icon: 'fi fi-rr-document' },
    { title: 'Genera la orden', icon: 'fi fi-rr-document-signed' },
    { title: 'Envía la orden', icon: 'fi fi-rr-envelope' }
  ];

  searchCtrl = new FormControl('');
  patientForm: FormGroup;
  examOrderForm: FormGroup;

  resultados: any[] = [];
  loading = false;
  showDropdown = false;
  minSearchLen = 4;
  tooShort = false;
  searchRutInvalid = false;

  infoRut: any = {};
  isNewUser = false;
  step1Unlocked = false;

  areaCodes: any[] = [];
  selectedAreaCode: any = {
    cou_phone_code: '56',
    cou_flag: 'fi-cl',
    cou_min_phone: 9,
    cou_max_phone: 9
  };

  flagDropdownOpen = false;

  paises: any[] = [];
  regiones: any[] = [];
  comunas: any[] = [];

  loadingPaises = false;
  loadingRegiones = false;
  loadingComunas = false;

  examenes: any = { examenes: [] };

  loadingCrearOrden = false;
  respuestaCrearOrden: any = null;
  errorCrearOrden = '';

  documentoGeneradoUrl = '';
  safeDocumentoGeneradoUrl: SafeResourceUrl | null = null;

  payloadOrdenGenerada: any = null;
  attIdDocumentoGenerado: any = null;

  readonly typeDocTalonario = 'orden';

  resendEmailCtrl = new FormControl('', [Validators.email]);
  loadingReenvio = false;
  mensajeReenvio = '';
  errorReenvio = '';

  private step1EditableControls = [
    'use_name',
    'paterno',
    'materno',
    'nacimiento',
    'telefonoCodigo',
    'telefono',
    'email',
    'use_address_cou_id',
    'use_address_reg_id',
    'use_address_com_id',
    'use_address_street',
    'use_address_number',
    'use_address_rest'
  ];

  constructor(
    private fb: FormBuilder,
    public reservaDoctor: ReservaDoctorService,
    private usuarioService: UsuarioService,
    private generalService: GeneralService,
    private encriptacionService: EncriptacionService,
    private fichaMedicaService: FichaMedicaService,
    private sanitizer: DomSanitizer,
    private router: Router

  ) {
    this.patientForm = this.fb.group({
      use_id: [''],
      use_rut: [
  '',
  [
    Validators.required,
    Validators.pattern(/^[0-9]{1,8}-?[0-9Kk]$/)
  ]
], use_name: ['', Validators.required],
      paterno: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")
      ]],
      materno: ['', [
        Validators.minLength(3),
        Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")
      ]],
      nacimiento: ['', Validators.required],
      telefonoCodigo: ['56', Validators.required],
      telefono: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      email: ['', [Validators.required, Validators.email, Validators.minLength(3)]],
      use_address_cou_id: [null, Validators.required],
      use_address_reg_id: [null, Validators.required],
      use_address_com_id: [null, Validators.required],
      use_address_street: ['', Validators.required],
      use_address_number: ['', Validators.required],
      use_address_rest: ['']
    });

    this.examOrderForm = this.fb.group({
      id_exam: ['', Validators.required],
      ordersText: ['', Validators.required],
      signatureType: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.usuario = this.encriptacionService.getUserInfo();
    this.pageInfo = this.encriptacionService.getPageInfo();
    // console.log(this.pageInfo);

    this.getCodPaises();
    this.getPaises();
    this.getExamenes();
    this.initAutocomplete();
    this.lockStep1Form();

    this.patientForm.get('use_address_cou_id')?.valueChanges.subscribe((couId: any) => {
      if (couId) this.onPaisChange(Number(couId));
    });

    this.patientForm.get('use_address_reg_id')?.valueChanges.subscribe((regId: any) => {
      if (regId) this.onRegionChange(Number(regId));
    });
  }


  get patientData(): any {
    return this.patientForm.getRawValue();
  }

  get examOrderData(): any {
    return this.examOrderForm.getRawValue();
  }

  get signatureType(): string {
    return this.examOrderForm.get('signatureType')?.value;
  }

  getExamenes(): void {
    this.fichaMedicaService.getListarExamType()
      .then((results: any) => {
        this.examenes = results || { examenes: [] };
      })
      .catch((error: any) => {
        console.error('Error al listar tipos de examen:', error);
        this.examenes = { examenes: [] };
      });
  }
  volverTalonario(): void {
    this.router.navigate(['/talonario']);
  }

  generarNuevaOrden(): void {
    this.currentStep = 0;

    this.steps = {
      searchPatient: true,
      examOrderData: false,
      examOrderSignature: false,
      examOrderSummary: false
    };

    this.searchCtrl.setValue('', { emitEvent: false });

    this.resultados = [];
    this.loading = false;
    this.showDropdown = false;
    this.tooShort = false;
    this.searchRutInvalid = false;

    this.infoRut = {};
    this.isNewUser = false;
    this.step1Unlocked = false;

    this.clearPatientForm();

    this.examOrderForm.reset({
      id_exam: '',
      ordersText: '',
      signatureType: ''
    });

    this.resendEmailCtrl.reset('');

    this.respuestaCrearOrden = null;
    this.documentoGeneradoUrl = '';
    this.safeDocumentoGeneradoUrl = null;

    this.loadingCrearOrden = false;
    this.errorCrearOrden = '';

    this.loadingReenvio = false;
    this.mensajeReenvio = '';
    this.errorReenvio = '';

    this.lockStep1Form();
  }
  nextFromStep1(): void {
    if (!this.isStep1Valid()) {
      this.patientForm.markAllAsTouched();
      return;
    }

    this.currentStep = 1;
    this.steps = {
      searchPatient: false,
      examOrderData: true,
      examOrderSignature: false,
      examOrderSummary: false
    };
  }

  volverStep1(): void {
    this.currentStep = 0;
    this.steps = {
      searchPatient: true,
      examOrderData: false,
      examOrderSignature: false,
      examOrderSummary: false
    };
  }

  nextFromStep2(): void {
    if (!this.isStep2Valid()) {
      this.examOrderForm.get('id_exam')?.markAsTouched();
      this.examOrderForm.get('ordersText')?.markAsTouched();
      return;
    }

    this.currentStep = 2;
    this.steps = {
      searchPatient: false,
      examOrderData: false,
      examOrderSignature: true,
      examOrderSummary: false
    };
  }

  volverStep2(): void {
    this.currentStep = 1;
    this.steps = {
      searchPatient: false,
      examOrderData: true,
      examOrderSignature: false,
      examOrderSummary: false
    };
  }

  async nextFromStep3(): Promise<void> {
  if (!this.isStep3Valid()) {
    this.examOrderForm.get('signatureType')?.markAsTouched();
    return;
  }

  if (this.loadingCrearOrden) {
    return;
  }

  this.loadingCrearOrden = true;
  this.errorCrearOrden = '';
  this.respuestaCrearOrden = null;
  this.documentoGeneradoUrl = '';
  this.safeDocumentoGeneradoUrl = null;
  this.mensajeReenvio = '';
  this.errorReenvio = '';
  this.attIdDocumentoGenerado = null;

  Swal.fire({
    allowOutsideClick: false,
    allowEscapeKey: false,
    html: `
      <div style="margin: 40px 0;">
        <i class="material-icons" style="color:#0e0087; font-size: 58px; margin-bottom:25px">schedule</i>
        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
          Generando documento
        </h1>
      </div>
    `,
    showConfirmButton: false
  });

  const payload = this.buildPayloadOrdenTalonarioDigital();

  this.payloadOrdenGenerada = JSON.parse(JSON.stringify(payload));

  // console.log('[ORDEN TALONARIO DIGITAL] Payload a enviar:', payload);

  try {
    const response: any = await this.fichaMedicaService.postCrearOrdenTalonarioDigital(payload);

    // console.log('[ORDEN TALONARIO DIGITAL] Respuesta servicio:', response);

    if (!response || response.status !== true) {
      this.errorCrearOrden = response?.mensaje || 'No fue posible generar la orden de examen.';

      Swal.fire({
        icon: 'error',
        title: 'No fue posible generar la orden',
        text: this.errorCrearOrden,
        confirmButtonColor: '#0e0087'
      });

      return;
    }

    this.respuestaCrearOrden = response;
    this.attIdDocumentoGenerado = this.getAttIdFromResponse(response);

    // console.log('[ORDEN TALONARIO DIGITAL] att_id documento generado:', this.attIdDocumentoGenerado);

    this.prepararDocumentoGenerado(response);

    this.currentStep = 3;
    this.steps = {
      searchPatient: false,
      examOrderData: false,
      examOrderSignature: false,
      examOrderSummary: true
    };

    Swal.close();

  } catch (error) {
    console.error('[ORDEN TALONARIO DIGITAL] Error al crear orden:', error);

    this.errorCrearOrden = 'No fue posible generar la orden de examen. Intente nuevamente.';

    Swal.fire({
      icon: 'error',
      title: 'Error al generar la orden',
      text: this.errorCrearOrden,
      confirmButtonColor: '#0e0087'
    });

  } finally {
    this.loadingCrearOrden = false;

    if (Swal.isLoading()) {
      Swal.close();
    }
  }
}

  private getAttIdFromResponse(response: any): any {
    return response?.att_id ||
      response?.attId ||
      response?.id_att ||
      response?.id_attachment ||
      response?.att?.att_id ||
      null;
  }
  volverStep3(): void {
    this.currentStep = 2;
    this.steps = {
      searchPatient: false,
      examOrderData: false,
      examOrderSignature: true,
      examOrderSummary: false
    };
  }

  setSignatureType(type: string): void {
    this.examOrderForm.patchValue({
      signatureType: type
    });
  }

  emitirOrden(): void {
    console.log('[ORDEN TALONARIO DIGITAL] Orden ya generada:', this.respuestaCrearOrden);
  }

  prepararDocumentoGenerado(response: any): void {
    const linkDoc = response?.linkDoc || '';

    if (!linkDoc) {
      this.documentoGeneradoUrl = '';
      this.safeDocumentoGeneradoUrl = null;
      console.warn('[ORDEN TALONARIO DIGITAL] La respuesta no trae linkDoc.');
      return;
    }

    this.documentoGeneradoUrl = this.buildDocumentoUrl(linkDoc);

    const previewUrl = this.documentoGeneradoUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';

    this.safeDocumentoGeneradoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(previewUrl);

    // console.log('[ORDEN TALONARIO DIGITAL] linkDoc recibido:', linkDoc);
    // console.log('[ORDEN TALONARIO DIGITAL] URL_DOCS:', this.URL_DOCS);
    // console.log('[ORDEN TALONARIO DIGITAL] URL documento completa:', this.documentoGeneradoUrl);
    // console.log('[ORDEN TALONARIO DIGITAL] URL preview:', previewUrl);
  }

  buildDocumentoUrl(linkDoc: string): string {
    if (!linkDoc) {
      return '';
    }

    if (linkDoc.startsWith('http://') || linkDoc.startsWith('https://')) {
      return linkDoc;
    }

    const base = this.URL_DOCS.endsWith('/')
      ? this.URL_DOCS.slice(0, -1)
      : this.URL_DOCS;

    const path = linkDoc.startsWith('/')
      ? linkDoc
      : '/' + linkDoc;

    return base + path;
  }

  descargarOrdenGenerada(): void {
    if (!this.documentoGeneradoUrl) {
      console.warn('[ORDEN TALONARIO DIGITAL] No existe URL de documento para descargar.');
      return;
    }

    window.open(this.documentoGeneradoUrl, '_blank');
  }

  async reenviarOrdenPorCorreo(): Promise<void> {
  this.mensajeReenvio = '';
  this.errorReenvio = '';

  const email = (this.resendEmailCtrl.value || '').toString().trim();

  if (!email) {
    this.errorReenvio = 'Debes ingresar un correo electrónico.';
    this.resendEmailCtrl.markAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Correo requerido',
      text: this.errorReenvio,
      confirmButtonColor: '#0e0087'
    });

    return;
  }

  if (this.resendEmailCtrl.invalid) {
    this.errorReenvio = 'El correo electrónico ingresado no es válido.';
    this.resendEmailCtrl.markAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Correo inválido',
      text: this.errorReenvio,
      confirmButtonColor: '#0e0087'
    });

    return;
  }

  const attId = this.attIdDocumentoGenerado || this.getAttIdFromResponse(this.respuestaCrearOrden);

  if (!attId) {
    this.errorReenvio = 'No existe att_id del documento generado. No es posible enviar la orden.';
    console.warn('[ORDEN TALONARIO DIGITAL] No se encontró att_id en respuestaCrearOrden:', this.respuestaCrearOrden);

    Swal.fire({
      icon: 'warning',
      title: 'Documento no disponible',
      text: this.errorReenvio,
      confirmButtonColor: '#0e0087'
    });

    return;
  }

  if (this.loadingReenvio) {
    return;
  }

  const payloadBase = this.payloadOrdenGenerada
    ? JSON.parse(JSON.stringify(this.payloadOrdenGenerada))
    : this.buildPayloadOrdenTalonarioDigital();

  const payload = {
    datosPaciente: payloadBase.datosPaciente,
    att_id: attId,
    user_mail: email,
    typeDoc: this.typeDocTalonario
  };

  // console.log('[ORDEN TALONARIO DIGITAL] Payload envío documento:', payload);

  this.loadingReenvio = true;

  Swal.fire({
    allowOutsideClick: false,
    allowEscapeKey: false,
    html: `
      <div style="margin: 40px 0;">
        <i class="material-icons" style="color:#0e0087; font-size: 58px; margin-bottom:25px">schedule</i>
        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
          Enviando documento
        </h1>
      </div>
    `,
    showConfirmButton: false
  });

  try {
    const response: any = await this.fichaMedicaService.postEnviarDocumentoTalonarioDigital(payload);

    // console.log('[ORDEN TALONARIO DIGITAL] Respuesta envío documento:', response);

    if (response && response.status === false) {
      this.errorReenvio = response.mensaje || 'No fue posible enviar la orden al correo indicado.';
      this.mensajeReenvio = '';

      Swal.fire({
        icon: 'error',
        title: 'No fue posible enviar la orden',
        text: this.errorReenvio,
        confirmButtonColor: '#0e0087'
      });

      return;
    }

    this.mensajeReenvio = response?.mensaje || 'La orden ha sido enviada al correo indicado.';
    this.errorReenvio = '';
    this.resendEmailCtrl.reset('');

    Swal.fire({
      icon: 'success',
      title: 'Orden enviada',
      text: this.mensajeReenvio,
      confirmButtonColor: '#0e0087'
    });

  } catch (error) {
    console.error('[ORDEN TALONARIO DIGITAL] Error al enviar documento:', error);

    this.errorReenvio = 'No fue posible enviar la orden al correo indicado.';
    this.mensajeReenvio = '';

    Swal.fire({
      icon: 'error',
      title: 'Error al enviar la orden',
      text: this.errorReenvio,
      confirmButtonColor: '#0e0087'
    });

  } finally {
    this.loadingReenvio = false;
  }
}

 isStep1Valid(): boolean {
  return this.patientForm.valid && this.step1Unlocked && !this.searchRutInvalid;
}

  isStep2Valid(): boolean {
    return !!this.examOrderForm.get('id_exam')?.valid &&
      !!this.examOrderForm.get('ordersText')?.valid;
  }

  isStep3Valid(): boolean {
    return !!this.examOrderForm.get('signatureType')?.valid;
  }

  buildPayloadOrdenTalonarioDigital(): any {
    const paciente = this.patientForm.getRawValue();
    const orden = this.examOrderForm.getRawValue();

    return {
      datosPaciente: {
        use_rut: paciente.use_rut || '',
        use_name: paciente.use_name || '',
        use_paternal_surname: paciente.paterno || '',
        use_maternal_surname: paciente.materno || '',
        use_birthdate: paciente.nacimiento || '',
        use_cod_area: String(paciente.telefonoCodigo || ''),
        use_movil_phone: String(paciente.telefono || ''),
        use_email: paciente.email || '',
        accion: paciente.use_id ? 'update' : 'insert',
        use_id: paciente.use_id || '',
        doc_id: this.usuario?.doc_id || null,
        ciudad: this.getRegionNombre(paciente.use_address_reg_id),
        direccion: paciente.use_address_street || '',
        nro: paciente.use_address_number || '',
        comuna: this.getComunaNombre(paciente.use_address_com_id)
      },
      datosOrden: {
        causal: null,
        med_ord_exa_typ_id: String(orden.id_exam || ''),
        id_tel_medical_order: '',
        med_ord_med_ord_typ_id: '3',
        med_ord_comment: orden.ordersText || ''
      }
    };
  }

  getCodPaises(): void {
    this.usuarioService.getCodPaises()
      .then((resp: any) => {
        this.areaCodes = this.normalizeList(resp);

        const chile = this.areaCodes.find((c: any) => String(c.cou_phone_code) === '56');

        if (chile) {
          this.selectedAreaCode = chile;

          this.patientForm.patchValue({
            telefonoCodigo: chile.cou_phone_code
          }, { emitEvent: false });

          this.setTelefonoValidators(chile);
        }
      })
      .catch(() => {
        this.areaCodes = [];
      });
  }

  getPaises(): void {
    this.loadingPaises = true;

    this.usuarioService.getPaises()
      .then((resp: any) => {
        this.paises = this.normalizeList(resp);

        const chile = this.paises.find((p: any) =>
          String(p.cou_id) === '1' ||
          String(p.cou_name || '').toLowerCase().includes('chile')
        );

        if (chile && !this.patientForm.get('use_address_cou_id')?.value) {
          this.patientForm.patchValue({
            use_address_cou_id: chile.cou_id
          }, { emitEvent: true });
        }
      })
      .catch((error: any) => {
        console.error('Error al obtener países:', error);
        this.paises = [];
      })
      .finally(() => {
        this.loadingPaises = false;
      });
  }

  onPaisChange(couId: number, limpiarSeleccion = true): void {
    if (!couId) {
      this.regiones = [];
      this.comunas = [];
      return;
    }

    if (limpiarSeleccion) {
      this.patientForm.patchValue({
        use_address_reg_id: null,
        use_address_com_id: null
      }, { emitEvent: false });
    }

    this.loadingRegiones = true;

    this.usuarioService.getRegiones(couId)
      .then((resp: any) => {
        this.regiones = this.normalizeList(resp);
      })
      .catch((error: any) => {
        console.error('Error al obtener regiones:', error);
        this.regiones = [];
      })
      .finally(() => {
        this.loadingRegiones = false;
      });
  }

  onRegionChange(regId: number, limpiarSeleccion = true): void {
    if (!regId) {
      this.comunas = [];
      return;
    }

    if (limpiarSeleccion) {
      this.patientForm.patchValue({
        use_address_com_id: null
      }, { emitEvent: false });
    }

    this.loadingComunas = true;

    this.usuarioService.getComunas(regId)
      .then((resp: any) => {
        this.comunas = this.normalizeList(resp);
      })
      .catch((error: any) => {
        console.error('Error al obtener comunas:', error);
        this.comunas = [];
      })
      .finally(() => {
        this.loadingComunas = false;
      });
  }

 private initAutocomplete(): void {
  this.searchCtrl.valueChanges.pipe(
    debounceTime(250),

    tap((v: any) => {
      const term = (v || '').toString().trim();

      if (!term) {
        this.clearPatientForm();
        this.showDropdown = false;
        this.tooShort = false;
        this.searchRutInvalid = false;
        this.resultados = [];
        this.infoRut = {};
        this.isNewUser = false;
        this.lockStep1Form();
        return;
      }

      this.showDropdown = true;
      this.tooShort = term.length < this.minSearchLen;
      this.loading = !this.tooShort;
    }),

    switchMap((v: string) => {
      const term = (v || '').toString().trim();

      if (!term || term.length < this.minSearchLen) {
        this.loading = false;
        return of([]);
      }

      return from(
        this.reservaDoctor.getVerificarPacienteAgenda({ rut: term })
      ).pipe(
        catchError(() => of([]))
      );
    })
  ).subscribe((resp: any) => {
    this.loading = false;

    this.resultados = Array.isArray(resp)
      ? resp
      : (resp ? [resp] : []);

    if (this.resultados.length > 0 && !this.isNewUser) {
      this.lockStep1Form();
    }
  });
}

onRutSearchInput(raw: string): void {
  const clean = this.normalizeRutDigits(raw);
  const formatted = this.formatRutWithDash(clean);

  this.searchCtrl.setValue(formatted, { emitEvent: true });

  // No se valida mientras escribe, para permitir coincidencias parciales.
  // La validación final se hace al presionar "Agregar usuario".
  this.searchRutInvalid = false;
}

  onEnterSearch(): void {
  let rut = (this.searchCtrl.value || '').toString().trim();

  rut = this.formatRutWithDash(rut);
  this.searchCtrl.setValue(rut, { emitEvent: false });

  if (!rut || rut.length < this.minSearchLen) {
    this.showDropdown = !!rut;
    this.tooShort = !!rut;
    this.resultados = [];
    return;
  }

  this.loading = true;
  this.showDropdown = true;
  this.searchRutInvalid = false;

  this.reservaDoctor.getVerificarPacienteAgenda({ rut })
    .then((resp: any) => {
      this.resultados = Array.isArray(resp)
        ? resp
        : (resp ? [resp] : []);
    })
    .catch(() => {
      this.resultados = [];
    })
    .finally(() => {
      this.loading = false;
    });
}

  seleccionarUsuario(item: any): void {
  const areaCode = this.areaCodes.find(
    (a: any) => String(a.cou_phone_code) === String(item?.use_cod_area)
  );

  if (areaCode) {
    this.selectedAreaCode = areaCode;
    this.setTelefonoValidators(areaCode);
  }

  this.isNewUser = false;
  this.searchRutInvalid = false;

  const raw = this.formatRutWithDash(item?.use_rut || item?.use_username || '');

  this.searchCtrl.setValue(raw, { emitEvent: false });
  this.infoRut = item;
  this.showDropdown = false;

  const countryId = item?.use_address_cou_id || item?.use_cou_id || 1;
  const regionId = item?.use_address_reg_id || null;
  const comunaId = item?.use_address_com_id || null;

  this.patientForm.patchValue({
    use_id: item?.use_id || '',
    use_rut: raw,
    use_name: item?.use_name || '',
    paterno: item?.use_paternal_surname || '',
    materno: item?.use_maternal_surname || '',
    nacimiento: this.toDateInput(item?.use_birthdate),
    email: item?.use_email || '',
    telefono: item?.use_movil_phone || item?.use_phone || '',
    telefonoCodigo: this.normArea(item?.use_cod_area) || '56',
    use_address_cou_id: countryId,
    use_address_reg_id: regionId,
    use_address_com_id: comunaId,
    use_address_street: item?.use_address_street || '',
    use_address_number: item?.use_address_number || '',
    use_address_rest: item?.use_address_rest || ''
  }, { emitEvent: false });

  this.unlockStep1Form();
  this.patientForm.updateValueAndValidity();

  if (countryId) {
    this.onPaisChange(Number(countryId), false);
  }

  if (regionId) {
    this.onRegionChange(Number(regionId), false);
  }
}

  normalizarRutComparacion(value: any): string {
  return (value || '')
    .toString()
    .replace(/\./g, '')
    .replace(/-/g, '')
    .toUpperCase()
    .replace(/[^0-9K]/g, '');
}

rutYaExisteExacto(): boolean {
  const rutBuscado = this.normalizarRutComparacion(this.searchCtrl.value);

  if (!rutBuscado) {
    return false;
  }

  return this.resultados.some((p: any) => {
    const rutPaciente = this.normalizarRutComparacion(p?.use_rut || p?.use_username);
    return rutPaciente === rutBuscado;
  });
}

puedeMostrarAgregarRutBuscado(): boolean {
  const typed = (this.searchCtrl.value || '').toString().trim();

  if (!typed || typed.length < this.minSearchLen) {
    return false;
  }

  return !this.rutYaExisteExacto();
}



  prepararNuevoUsuario(): void {
  const typed = (this.searchCtrl.value || '').toString().trim();

  if (!typed) {
    this.lockStep1Form();
    return;
  }

  if (this.rutYaExisteExacto()) {
    this.searchRutInvalid = false;
    this.lockStep1Form();
    return;
  }

  const rutValido = this.generalService.validaRutChileno(typed);

  if (!rutValido) {
    this.searchRutInvalid = true;
    this.showDropdown = true;
    this.isNewUser = false;
    this.clearPatientForm();
    this.lockStep1Form();
    return;
  }

  this.searchRutInvalid = false;
  this.isNewUser = true;
  this.showDropdown = false;
  this.resultados = [];

  const defaultCountry = this.getDefaultCountryId();

  this.patientForm.reset({
    use_id: '',
    use_rut: typed,
    use_name: '',
    paterno: '',
    materno: '',
    nacimiento: '',
    telefonoCodigo: this.selectedAreaCode?.cou_phone_code || '56',
    telefono: '',
    email: '',
    use_address_cou_id: defaultCountry,
    use_address_reg_id: null,
    use_address_com_id: null,
    use_address_street: '',
    use_address_number: '',
    use_address_rest: ''
  });

  this.unlockStep1Form();
  this.patientForm.updateValueAndValidity();

  if (defaultCountry) {
    this.onPaisChange(Number(defaultCountry), true);
  }
}

  lockStep1Form(): void {
    this.step1Unlocked = false;

    this.step1EditableControls.forEach(control => {
      this.patientForm.get(control)?.disable({ emitEvent: false });
    });
  }

  unlockStep1Form(): void {
    this.step1Unlocked = true;

    this.step1EditableControls.forEach(control => {
      this.patientForm.get(control)?.enable({ emitEvent: false });
    });
  }

  clearPatientForm(): void {
    const defaultCountry = this.getDefaultCountryId();

    this.patientForm.reset({
      use_id: '',
      use_rut: '',
      use_name: '',
      paterno: '',
      materno: '',
      nacimiento: '',
      telefonoCodigo: this.selectedAreaCode?.cou_phone_code || '56',
      telefono: '',
      email: '',
      use_address_cou_id: defaultCountry,
      use_address_reg_id: null,
      use_address_com_id: null,
      use_address_street: '',
      use_address_number: '',
      use_address_rest: ''
    });

    this.regiones = [];
    this.comunas = [];
  }

  onAreaCodeDropdownClick(event: MouseEvent): void {
    event.stopPropagation();

    if (!this.step1Unlocked) return;

    this.toggleFlagDropdown();
  }

  toggleFlagDropdown(): void {
    this.flagDropdownOpen = !this.flagDropdownOpen;
  }

  selectAreaCode(areaCode: any): void {
    this.selectedAreaCode = areaCode;
    this.flagDropdownOpen = false;

    this.patientForm.patchValue({
      telefonoCodigo: areaCode.cou_phone_code
    });

    this.setTelefonoValidators(areaCode);
  }

  setTelefonoValidators(areaCode: any): void {
    const telCtrl = this.patientForm.get('telefono');

    telCtrl?.setValidators([
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(areaCode.cou_min_phone),
      Validators.maxLength(areaCode.cou_max_phone)
    ]);

    telCtrl?.updateValueAndValidity();
  }

  getPaisNombre(couId: any): string {
    const pais = this.paises.find((p: any) => String(p.cou_id) === String(couId));
    return pais ? pais.cou_name : '—';
  }

  getRegionNombre(regId: any): string {
    const region = this.regiones.find((r: any) => String(r.reg_id) === String(regId));
    return region ? region.reg_name : '—';
  }

  getComunaNombre(comId: any): string {
    const comuna = this.comunas.find((c: any) => String(c.com_id) === String(comId));
    return comuna ? comuna.com_name : '—';
  }

  getTipoExamenNombre(idExam: any): string {
    const examen = this.examenes?.examenes?.find(
      (e: any) => String(e.exa_typ_id) === String(idExam)
    );

    return examen ? examen.exa_typ_name : '—';
  }

  getSignatureName(): string {
    if (this.signatureType === 'digital') return 'Firma digital';
    return '—';
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ'´\s]*$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  allowOnlyRutChars(event: KeyboardEvent): void {
  const key = event.key;

  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'Tab' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Home' ||
    key === 'End'
  ) {
    return;
  }

  if (!/^[0-9kK]$/.test(key)) {
    event.preventDefault();
  }
}

onRutPaste(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') || '';

  if (!/^[0-9kK.-]+$/.test(pastedText)) {
    event.preventDefault();
  }
}



  normalizeRutDigits(v: string): string {
  return (v || '')
    .toString()
    .replace(/\./g, '')
    .replace(/-/g, '')
    .toUpperCase()
    .replace(/[^0-9K]/g, '');
}

formatRutWithDash(v: string): string {
  const clean = this.normalizeRutDigits(v);

  if (clean.length <= 1) {
    return clean;
  }

  return clean.slice(0, -1) + '-' + clean.slice(-1);
}

  toDateInput(date: any): string {
    if (!date) return '';
    return String(date).substring(0, 10);
  }

  normArea(area: any): string {
    return String(area || '56');
  }

  normalizeList(resp: any): any[] {
    if (Array.isArray(resp)) return resp;
    if (Array.isArray(resp?.data)) return resp.data;
    if (Array.isArray(resp?.rows)) return resp.rows;
    if (Array.isArray(resp?.consulta)) return resp.consulta;
    return [];
  }

  getDefaultCountryId(): any {
    const chile = this.paises.find((p: any) =>
      String(p.cou_id) === '1' ||
      String(p.cou_name || '').toLowerCase().includes('chile')
    );

    return chile?.cou_id || this.paises[0]?.cou_id || 1;
  }

  @HostListener('document:click')
  clickOutside(): void {
    this.showDropdown = false;
    this.flagDropdownOpen = false;
  }


}
